export default __webpack_public_path__ + "static/media/868.165b743f.png";